import { useMemo } from 'react';
import { getSelectedServicesBySegments } from '../AdditionalBaggage/utils';
import { getPriceToPay } from '../../BaggagePage/utils';
export const serviceForMultipleSegments = (service) => {
    var _a;
    return ((_a = service.segmentIds[0]) === null || _a === void 0 ? void 0 : _a.length) > 1;
};
export const useSelectedServicesBySegments = (services, segments, selectedServices) => {
    const selectedItems = useMemo(() => {
        const selectedServicesBySegments = getSelectedServicesBySegments(services, selectedServices, segments);
        return selectedServicesBySegments.sort((a, b) => {
            if (a.allSegments && !b.allSegments) {
                return -1;
            }
            else if (!a.allSegments && b.allSegments) {
                return 1;
            }
            return +a.service.id - +b.service.id;
        });
    }, [services, selectedServices, segments]);
    const totalPrice = useMemo(() => getPriceToPay(selectedServices, services), [selectedItems, services]);
    return {
        selectedItems,
        hasSelected: selectedItems.length > 0,
        totalPrice
    };
};
